/**
 * Copyright (C) 2020 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useContext } from 'react';
import TailTagsOverlay from './TailTagsOverlay';
import OverlaysWrapper from './OverlaysWrapper';
import TailTagSizeController from './TailTagSizeController';

import { MapActionsContext, useSelectorWithMapId } from '../map/BaseMapContainer';
import { useDispatch } from 'react-redux';
import { TailTagSize } from '../../../store/maps/reducer';
import { selectTailTagOverlaysPanelShown, selectTerminalTagSize } from '../../../store';

const TAIL_TAG_OVERLAYS_PANEL_TOP_PX = 27;

export function TailTagOverlaysPanel() {
  const dispatch = useDispatch();
  const mapActionsContext = useContext(MapActionsContext);

  const tailTagOverlaysPanelShown = useSelectorWithMapId(selectTailTagOverlaysPanelShown);
  const terminalTagSize = useSelectorWithMapId(selectTerminalTagSize);

  const { hideTailTagOverlaysPanel, setTerminalTagsSize } = mapActionsContext.mapActions;

  const top = TAIL_TAG_OVERLAYS_PANEL_TOP_PX + 'px';

  return (
    <OverlaysWrapper
      headerTitle="Tag Configuration"
      queryParamsToNotHidePanel={['#tail_tag_overlays_panel_btn_container']}
      shown={tailTagOverlaysPanelShown}
      hidePanel={() => {
        dispatch(hideTailTagOverlaysPanel());
      }}
      top={top}
    >
      <TailTagsOverlay />
      <TailTagSizeController
        terminalTagSize={terminalTagSize}
        setTerminalTagsSize={(tagSize: TailTagSize) => {
          dispatch(setTerminalTagsSize(tagSize));
        }}
      />
    </OverlaysWrapper>
  );
}

export default TailTagOverlaysPanel;
